import { render, staticRenderFns } from "./iconRefNew.vue?vue&type=template&id=dd51c95c&scoped=true&"
import script from "./iconRefNew.vue?vue&type=script&lang=js&"
export * from "./iconRefNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd51c95c",
  null
  
)

export default component.exports